import { useTranslation } from 'react-i18next';
import UnauthorizedError from 'api/errors/UnauthorizedError';

const useErrorMessage = (error: null | Error): string | null => {
  const { t } = useTranslation();

  if (!error) return null;

  if (error instanceof UnauthorizedError) return t('invalidCredentials');

  return t('unknownError');
};

export default useErrorMessage;
